import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getApp } from "firebase/app";

const FirebaseStayPolicy = () => {
  const location = useLocation();
  const app = getApp("ohyaFinanceFirebase");
  const analytics = getAnalytics(app);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (location.pathname === "/loan/policy") {
      timeoutRef.current = window.setTimeout(() => {
        logEvent(analytics, "finance_loan_policy_loan_time_stay", {
          time_length: 10,
          page_location: "https://www.ohyafinance.com/loan/policy",
        });
      }, 10000);
    }

    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [location.pathname]);

  return null;
};

export default FirebaseStayPolicy;
